export function getServiceVoucherDiscount(service) {
    if (!service.voucher || !service.voucher.id)
        return 0;

    return service.voucher.discount_type == "percentage"
        ? parseFloat(service.quantity) * parseFloat(service.price) * (parseFloat(service.voucher.amount) * 0.01)
        : parseFloat(service.voucher.amount);
}

export function formatBookingCreationData(shopId, data, items, voucher, address) {
    let formattedData = {
        discount_code: voucher && voucher.id ? voucher.code : null,
        shop_id: shopId,
        voucher_id: data.voucher_id,
        datetime: data.datetime,
        points_used: data.points_used,
        is_home: !!data.is_home,
        payment_method: data.payment_method,
        services: formatServices(items.services),
        packages: formatServices(items.packages),
        address_id: address && address.id ? address.id : null,
    };

    if (address && !address.id) {
        formattedData.address = address;
    }

    return formattedData;
}

function formatServices(services) {
    return services.map(service => {
        if (service.type == "service") {
            return {
                id: service.id,
                type: service.type,
                quantity: service.quantity,
                discount_code: service.voucher && service.voucher.id ? service.voucher.code : null,
                expert_ids: service.experts || [],
                shop_service_id: service.shop_service_id,
            }
        }

        const formatPackageItems = ({ id, experts, package_id, subcategory_id, quantity, type, shop_service_id }) =>
            ({ id, expert_ids: experts || [], package_id, subcategory_id, quantity, type, shop_service_id });

        return {
            id: service.id,
            type: service.type,
            quantity: service.quantity,
            discount_code: service.voucher && service.voucher.id ? service.voucher.code : null,
            items: service.packageItems.map(formatPackageItems),
        }
    });
}